export const supportedLanguages = [
  { code: "en", label: "English" },
  { code: "hi", label: "Hindi" },
  { code: "ta", label: "Tamil" },
  { code: "te", label: "Telugu" },
  { code: "kn", label: "Kannada" },
  { code: "mr", label: "Marathi" },
  { code: "gu", label: "Gujarati" },
  { code: "bn", label: "Bengali" },
  { code: "ml", label: "Malayalam" },
  { code: "pa", label: "Punjabi" },
  { code: "ur", label: "Urdu", rtl: true },
  { code: "ar", label: "Arabic", rtl: true }
];

/**
 * Returns language label given ISO code
 * @param {string} code
 * @returns {string} label
 */
export const getLanguageLabel = (code) => {
  return supportedLanguages.find((l) => l.code === code)?.label || "Unknown";
};

/**
 * Returns true if language is right-to-left
 * @param {string} code
 * @returns {boolean}
 */
export const isRTL = (code) => {
  return supportedLanguages.find((l) => l.code === code)?.rtl === true;
};



